import {
    FETCH_SUBACCOUNTEVENTSAPPLYS
} from '../actions/subAccount';


export const initialState = {
    isFetching: true,
    data: null
};

export const subAccountEventsApplys = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_SUBACCOUNTEVENTSAPPLYS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_SUBACCOUNTEVENTSAPPLYS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/subAccount.js